module.exports = __webpack_public_path__ + "static/media/usecase.ea39e544.png";